package org.dronda.app.web.ui.components

import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

object AppColors {
    val surface = rgb(255, 255, 255)
    val primary = rgb(35, 0, 96)
    val onPrimary = rgb(255, 255, 255)
    val muted = rgb(100, 100, 100)
    val subtleSurface = rgb(240, 238, 248)
    val accent = rgb(176, 32, 48)
    val accentSurface = rgb(253, 236, 238)
    val success = rgb(30, 120, 60)
    val danger = rgb(200, 0, 0)
    val warning = rgb(160, 90, 0)
    val scrim = rgba(0, 0, 0, 0.5)
}
